import React from "react";
import { injectIntl } from "react-intl";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// core components
import GridContainer from "@app/components/Grid/GridContainer";
import GridItem from "@app/components/Grid/GridItem";
import Card from "@app/components/Card/Card";
import CardHeader from "@app/components/Card/CardHeader";
import CardBody from "@app/components/Card/CardBody";

import OPSCalcLink from "@app/views/LandingPages/Sections/OPSCalcLink";

import stripeLogo from "@app/assets/img/partners/Stripe-blurple-white-bg-sm.png";
import googleCloudLogo from "@app/assets/img/partners/google-cloud_lockup_horiz.png";
import reactLogo from "@app/assets/img/partners/React-logo.png";

import partnersStyle from "@app/assets/jss/material-kit-pro-react/views/landingPageSections/featuresStyle";

function Partners(props) {
    const { classes } = props;


    return (
        <div className={classes.features4}>
            <GridContainer>
                <GridItem xs={12} sm={4} md={4}>
                    <Card raised>
                        <CardHeader image>
                            <a href="#stripe" onClick={e => e.preventDefault()}>
                                <img src={stripeLogo} alt="Stripe" />
                            </a>
                            <div
                                className={classes.coloredShadow}
                                style={{
                                    backgroundImage: `url(${stripeLogo})`,
                                    opacity: "1"
                                }}
                            />
                        </CardHeader>
                        <CardBody>
                            <h3 className={classes.cardTitle}>
                                Payments infrastructure for the internet
                            </h3>
                            <p className={classes.cardDescription}>
                                Millions of businesses of all sizes use <b>Stripe</b> to accept payments online.
                            </p>
                        </CardBody>
                    </Card>
                </GridItem>
                <GridItem xs={12} sm={4} md={4}>
                    <Card raised>
                        <CardHeader image>
                            <a href="#google-cloud" onClick={e => e.preventDefault()}>
                                <img src={googleCloudLogo} alt="Google CLoud" />
                            </a>
                            <div
                                className={classes.coloredShadow}
                                style={{
                                    backgroundImage: `url(${googleCloudLogo})`,
                                    opacity: "1"
                                }}
                            />
                        </CardHeader>
                        <CardBody>
                            <h3 className={classes.cardTitle}>
                                Solve more with <b>Google Cloud</b> & LocalPro
                            </h3>
                            <p className={classes.cardDescription}>
                                Meet your business challenges head on with cloud computing services from <b>Google</b>.
                            </p>
                        </CardBody>
                    </Card>
                </GridItem>
                <GridItem xs={12} sm={4} md={4}>
                    <Card raised>
                        <CardHeader image>
                            <a href="#reactJS" onClick={e => e.preventDefault()}>
                                <img src={reactLogo} alt="Stripe" />
                            </a>
                            <div
                                className={classes.coloredShadow}
                                style={{
                                    backgroundImage: `url(${reactLogo})`,
                                    opacity: "1"
                                }}
                            />
                        </CardHeader>
                        <CardBody>
                            <h3 className={classes.cardTitle}>
                                <b>React</b> makes it painless to create interactive UIs.
                            </h3>
                            <p className={classes.cardDescription}>
                                Efficient and flexible user interfaces for web and mobile.
                            </p>
                        </CardBody>
                    </Card>
                </GridItem>
            </GridContainer>
            <hr/>
            <OPSCalcLink />
        </div>
        );
    }
    
export default injectIntl(withStyles(partnersStyle)(Partners));